import { BrowserRouter, Routes, Route } from 'react-router-dom';

// pages & components
import NavBar from './components/Navbar';
import Home from './pages/Home';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar />
        <div className="pages">
          <Routes>
            <Route
              path="/"
              element={<Home />}
            />
            <Route
              path="*"
              element={<h3>Page not found</h3>}
            />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
